module.exports = __webpack_public_path__ + "static/media/view4.796a63ca.jpg";